// extracted by mini-css-extract-plugin
module.exports = {"legalTextContainer":"LegalTextBanner_legalTextContainer__0sTC_","legalText":"LegalTextBanner_legalText___SHx7"};